export function generateGradientFromId(id: number): string {
  const hue = (id * 137.5) % 360;
  return `linear-gradient(${180}deg, hsl(${hue}, 60%, 60%), hsl(${hue}, 60%, 50%))`;
}
